// Importación de Axios
import axios from "axios";
import store from "../store";
import { RUTA_SERVIDOR_BACKEND } from "./configuraciones";

/*  

Sección Filiales 

*/

export const getFiliales = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/filiales`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveFiliales = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/filiales`,
      {
        name: data.filialModel,
        business_name: data.razonSocialModel,
        rut: data.rutModel,
        sector: data.sectorModel,
        legal_representative: data.representanteLegalModel,
        inttra_id: data.inttraModel,
        id_country: data.paisModel.id,
        city: data.ciudadModel.id,
        address: data.direccionModel,
        postal_code: data.codigoPostalModel,
        id_status: data.estadoModel,
        phone: data.telefonoModel,
        fax: data.faxModel,
        email: data.emailModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Deshabilitar
export const deshabilitarFilial = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarFilial`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Registrar usuario
export const updateFiliales = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/filiales`,
      {
        id: data.id,
        name: data.filialModel,
        business_name: data.razonSocialModel,
        rut: data.rutModel,
        sector: data.sectorModel,
        legal_representative: data.representanteLegalModel,
        inttra_id: data.inttraModel,
        id_country: data.paisModel.id,
        city: data.ciudadModel.id,
        address: data.direccionModel,
        postal_code: data.codigoPostalModel,
        phone: data.telefonoModel,
        fax: data.faxModel,
        email: data.emailModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })
    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deleteFilial = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/filiales/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 





Sección Clientes 
   
*/

export const filtrarClientes = async (payload) => {
  const result = await axios.post(`${RUTA_SERVIDOR_BACKEND}/clientes/filtrarClientes`, payload, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });
  return result;
}

export const getClientes = () =>
  axios.get(`${RUTA_SERVIDOR_BACKEND}/clientes`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }).then(({ data }) => data);

export const saveClientes = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/clientes`,
      {
        id: data.id,
        name: data.exportadorModel,
        business_name: data.razonSocialModel,
        serial_number: data.rutModel,
        sections: data.giroModel,
        id_shipper: data.embarcadorModel.id,
        id_commercial_user: data.responsableModel.id,
        legal_representative: data.representanteLegalModel,
        id_modules: data.modulosSistemasModel,
        id_client_category: data.tipoClienteModel.id,
        active: data.estadoModel,
        id_branch: data.filialModel.id,
        id_sales_user: data.ventasModel.id,
        id_customer_user: data.customerModel.id
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Actualizar
export const updateClientes = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/clientes/${data.id}`,
      {
        id: data.id,
        name: data.exportadorModel,
        business_name: data.razonSocialModel,
        serial_number: data.rutModel,
        sections: data.giroModel,
        id_shipper: data.embarcadorModel.id,
        id_commercial_user: data.responsableModel.id,
        legal_representative: data.representanteLegalModel,
        id_modules: data.modulosSistemasModel,
        id_client_category: data.tipoClienteModel.id,
        id_branch: data.filialModel.id,
        id_customer_user: data.customerModel.id,
        id_sales_user: data.ventasModel.id,
        tier: data.tier.id ?? null
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const getResposblesPaisCliente = (country_id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/clientes/responsiblesByIdCountry/${country_id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

// Deshabilitar
export const deshabilitarCliente = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarCliente`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deleteCliente = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/clientes/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 

Sección Clientes - Contactos
 
*/

export const getClientesContactos = async (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarContactosClientes/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveClientesContactos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/crearContactoCliente`,
      {
        id_client: data.id,
        firstname: data.nombreModel,
        lastname: data.apellidosModel,
        position: data.cargoModel,
        tel: data.telefonoModel,
        cel: data.celularModel,
        fax: data.faxModel,
        email: data.emailModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateClientesContactos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarContactoCliente/${data.id}`,
      {
        id: data.id,
        firstname: data.nombreModel,
        lastname: data.apellidosModel,
        position: data.cargoModel,
        tel: data.telefonoModel,
        cel: data.celularModel,
        fax: data.faxModel,
        email: data.emailModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteClienteContactos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarContactoCliente/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 

Sección Clientes - Direcciones

*/

export const getClientesDirecciones = async (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarDireccionesClientes/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveClientesDirecciones = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/crearDireccionCliente`,
      {
        id_client: data.id,
        address: data.direccionModel,
        id_region: data.regionModel.id,
        id_provincia: data.provinciaModel.id,
        id_comuna: data.comunaModel.id,
        localidad: data.localidadModel
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateClientesDirecciones = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarDireccionCliente/${data.id}`,
      {
        id_client: data.id,
        address: data.direccionModel,
        id_region: data.regionModel.id,
        id_provincia: data.provinciaModel.id,
        id_comuna: data.comunaModel.id,
        localidad: data.localidadModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteClienteDirecciones = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarDireccionCliente/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 

Sección Clientes - Plantas

*/

export const getClientesPlantas = async (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarPlantas/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const existPlanta = async (payload) => (
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/plantas/find`, payload, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    }
  })
);

    
export const saveClientesPlantas = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/crearPlanta`,data,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};



export const deleteClientePlantas = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarPlanta/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateClientesPlantas = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios.post(`${RUTA_SERVIDOR_BACKEND}/actualizarPlanta`,data,
      {
        headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 

Sección Clientes - Agencias Aduana

*/

export const getClientesAgenciasAduana = async (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarAgencias/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveClientesAgenciasAduana = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/agregarAgencia`,
      {
        id_client: data.id,
        id_carrier: data.agenciaAduanaModel.id,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateClientesAgenciasAduana = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarAgencia/${data.id}`,
      {
        id: data.id,
        id_carrier: data.agenciaAduanaModel.id,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteClientesAgenciasAduana = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarAgencia/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 

Sección Clientes - Consignatarios

*/

export const getClientesConsignatarios = async (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarConsignatarios/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveClientesConsignatarios = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/agregarConsignatario`,
      {
        id_client: data.id,
        name: data.nombreModel,
        id_country: data.paisModel.id,
        id_region: data.regionModel.id,
        id_provincia: data.provinciaModel.id,
        id_comuna: data.comunaModel.id,
        id_localidad: data.localidadModel.id,
        address: data.direccionModel,
        contact_name: data.contactoModel,
        email: data.emailModel,
        phone: data.telefonoModel,
        zip_code: data.codigoPostalModel,
        fax: data.faxModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateClientesConsignatarios = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarConsignatario/${data.id}`,
      {
        id: data.id,
        name: data.nombreModel,
        id_country: data.paisModel.id,
        id_region: data.regionModel.id,
        id_provincia: data.provinciaModel.id,
        id_comuna: data.comunaModel.id,
        id_localidad: data.localidadModel.id,
        address: data.direccionModel,
        contact_name: data.contactoModel,
        email: data.emailModel,
        phone: data.telefonoModel,
        zip_code: data.codigoPostalModel,
        fax: data.faxModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteClientesConsignatarios = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarConsignatario/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 

Sección Clientes - Notificados

*/

export const getClientesNotificados = async (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarNotificados/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveClientesNotificados = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/agregarNotificado`,
      {
        id_client: data.id,
        name: data.nombreModel,
        id_country: data.paisModel.id,
        id_region: data.regionModel.id,
        id_provincia: data.provinciaModel.id,
        id_comuna: data.comunaModel.id,
        id_localidad: data.localidadModel.id,
        address: data.direccionModel,
        contact_name: data.contactoModel,
        email: data.emailModel,
        phone: data.telefonoModel,
        zip_code: data.codigoPostalModel,
        fax: data.faxModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateClientesNotificados = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarNotificado/${data.id}`,
      {
        id: data.id,
        name: data.nombreModel,
        id_country: data.paisModel.id,
        id_region: data.regionModel.id,
        id_provincia: data.provinciaModel.id,
        id_comuna: data.comunaModel.id,
        id_localidad: data.localidadModel.id,
        address: data.direccionModel,
        contact_name: data.contactoModel,
        email: data.emailModel,
        phone: data.telefonoModel,
        zip_code: data.codigoPostalModel,
        fax: data.faxModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteClientesNotificados = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarNotificado/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 

Sección Clientes - Afiliados

*/

export const getClientesAfiliados = async (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarAfiliados/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveClientesAfiliados = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/agregarAfiliado/${data.id}`,
      {
        id: data.id,
        id_client: data.nombreAfiliadoModel.id,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteClientesAfiliados = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarAfiliado/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 

Sección Clientes - Productos

*/

export const getClientesProductos = async (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarProductosCliente/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveClientesProductos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/agregarProductoCliente`,
      {
        id_client: data.id,
        name: data.nombreModel,
        temp: data.temperaturaModel,
        vent: data.ventilacionModel,
        vent_cbm: data.ventilacionCbmModel,
        hs_code: data.harmonizedSystemCodesModel,
        id_product_type: data.categoriaProductoModel.id,
        asoex_code: data.codigoAsoexModel,
        comment: data.comentariosModel,
        active: data.estadoModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateClientesProductos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarProductoCliente/${data.id}`,
      {
        id: data.id,
        name: data.nombreModel,
        temp: data.temperaturaModel,
        vent: data.ventilacionModel,
        vent_cbm: data.ventilacionCbmModel,
        hs_code: data.harmonizedSystemCodesModel,
        id_product_type: data.categoriaProductoModel.id,
        asoex_code: data.codigoAsoexModel,
        comment: data.comentariosModel,
        active: data.estadoModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteClientesProductos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarProductoCliente/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};


export const getClientesConfiguraciones = async () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/clientes/configuraciones`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);


export const saveClientesConfiguraciones = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/clientes/configuraciones`,
      {
        tier: data.tier
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};


/* 

Sección Usuarios 

*/

// Listar
export const getUsuarios = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/usuarios`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

// Listar usuario actual
export const getUsuario = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/usuarioActual`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);


// Registrar usuario
export const actualizarPerfil = async (data) => {

  let dataResponse;

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/usuarioActual`, data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ data }) {
      dataResponse = data;
    }).catch(({ data }) => {
      dataResponse = data.message;
    });

  return dataResponse;
};

export const resetPassword = async (data) => {

  let dataAux = [];

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/resetPassword`, { username: data },
      {
        headers: {
          Accept: "application/json",
        },
      }
    )
    .then(function ({ data }) {
      dataAux = data;
    })

    .catch(({ data }) => {
      dataAux = data;
    });

  return dataAux;
};


// Registrar usuario
export const saveUsuarios = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/usuarios`,
      {
        rut: data.rutModel,
        username: data.usuarioModel,
        email: data.emailModel,
        first_name: data.nombreModel,
        last_name: data.apellidosModel,
        phone: data.telefonoModel,
        cell_phone: data.celularModel,
        id_role: data.rolModel.id,
        id_client: data.clienteModel.id,
        id_shipper: data.embarcadorModel.id,
        position: data.cargoModel,
        branch: data.filialModel.id,
        type_seleccion: data.selectAuxSeleccionado,
        password: data.contrasenaModel
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Deshabilitar
export const cambioEstado = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/usuarioEstado`,
      {
        uid: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Registrar usuario
export const updateUsuarios = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Actualizar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/usuarios`,
      {
        id_user: data.id_user,
        uid: data.uid,
        rut: data.rutModel,
        username: data.usuarioModel,
        email: data.emailModel,
        first_name: data.nombreModel,
        last_name: data.apellidosModel,
        phone: data.telefonoModel,
        cell_phone: data.celularModel,
        id_role: data.rolModel.id,
        id_client: data.clienteModel.id,
        id_shipper: data.embarcadorModel.id,
        position: data.cargoModel,
        branch: data.filialModel.id,
        type_seleccion: data.selectAuxSeleccionado,
        nps: data.nps,
        prs: data.prs,
        rs: data.rs,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deleteUsuarios = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/usuarios/${data.id}/${data.tipo}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updatePassword = async ({ userId, newPassword }) => (
  await axios.put(`${RUTA_SERVIDOR_BACKEND}/usuarios/${userId}`, { newPassword }, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    }
  })
)

export const existUser = async (payload) => (
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/usuarios/find`, payload, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    }
  })
);

/* 





Sección Roles 

*/

export const getRoles = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/roles`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

/* 



 

Sección Proveedores 

*/

export const getProveedores = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/proveedores`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveProveedores = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/proveedores`,
      {
        name: data.nombreModel,
        serial_number: data.rutModel,
        id_carrier_type: data.tipoModel.id,
        giro: data.giroModel,
        id_country: data.paisModel.id,
        id_region: data.regionModel.id,
        id_provincia: data.provinciaModel.id,
        id_comuna: data.comunaModel.id,
        id_localidad: data.localidadModel.id,
        address: data.direccionModel,
        lat: data.latitudModel,
        lon: data.longitudModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Actualizar
export const updateProveedores = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarProveedor/${data.id}`,
      {
        id: data.id,
        name: data.nombreModel,
        serial_number: data.rutModel,
        id_carrier_type: data.tipoModel.id,
        giro: data.giroModel,
        id_country: data.paisModel.id,
        id_region: data.regionModel.id,
        id_provincia: data.provinciaModel.id,
        id_comuna: data.comunaModel.id,
        id_localidad: data.localidadModel.id,
        address: data.direccionModel,
        lat: data.latitudModel,
        lon: data.longitudModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Deshabilitar
export const deshabilitarProveedor = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarProveedor`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deleteProveedor = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/proveedores/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
/* 

Sección Proveedores - Coordinadores

*/
export const getProveedoresCoordinadores = async (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarCoordinadores/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveProveedoresCoordinadores = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/crearCoordinador`,
      {
        id_carrier: data.id,
        id_country: data.paisModel.id,
        first_name: data.nombreModel,
        last_name: data.apellidoModel,
        rut: data.rutModel,
        phone: data.telefonoModel,
        email: data.emailModel,
        username: data.nombreUsuarioModel,
        password: data.contrasenaModel,
        repeat_password: data.repetirContrasenaModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateProveedoresCoordinadores = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarCoordinador/${data.id}`,
      {
        id: data.id,
        id_user: data.id_user,
        first_name: data.nombreModel,
        last_name: data.apellidoModel,
        rut: data.rutModel,
        phone: data.telefonoModel,
        email: data.emailModel,
        username: data.nombreUsuarioModel,
        password: data.contrasenaModel,
        repeat_password: data.repetirContrasenaModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deshabilitarProveedoresCoordinadores = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarCoordinador/${data.id}`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteProveedoresCoordinadores = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarCoordinador/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 

Sección Proveedores - Conductores

*/
export const getProveedoresConductores = async (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarConductores/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveProveedoresConductores = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/crearConductor`,
      {
        id_carrier: data.id,
        first_name: data.nombreModel,
        last_name: data.apellidoModel,
        rut: data.rutModel,
        phone: data.telefonoModel,
        username: data.nombreUsuarioModel,
        email: data.emailModel,
        password: data.contrasenaModel,
        repeat_password: data.repetirContrasenaModel,
        driver_license: data.licenciaConducirModel,
        expiration_date: data.fechaVencimientoModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateProveedoresConductores = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarConductor/${data.id}`,
      {
        id: data.id,
        id_user: data.id_user,
        first_name: data.nombreModel,
        last_name: data.apellidoModel,
        rut: data.rutModel,
        phone: data.telefonoModel,
        username: data.nombreUsuarioModel,
        email: data.emailModel,
        password: data.contrasenaModel,
        repeat_password: data.repetirContrasenaModel,
        driver_license: data.licenciaConducirModel,
        expiration_date: data.fechaVencimientoModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deshabilitarProveedoresConductores = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarConductor/${data.id}`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteProveedoresConductores = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarConductor/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 

Sección Proveedores - Camiones

*/
export const getProveedoresCamiones = async (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarCamiones/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveProveedoresCamiones = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/crearCamion`,
      {
        carrier_id: data.id,
        patente: data.patenteModel,
        seguro_vigencia: data.vigenciaSeguroModel,
        vencimiento_seguro: data.vencVigenciaSeguroModel,
        cert_rev_tecnica: data.revisionTecnicaModel,
        fecha_venc_rev_tecnica: data.vencRevisionTecnicaModel,
        permiso_circulacion: data.permisoCirculacionModel,
        fecha_venc_perm_circulacion: data.vencPermisoCirculacionModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateProveedoresCamiones = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarCamion/${data.id}`,
      {
        id: data.id,
        patente: data.patenteModel,
        seguro_vigencia: data.vigenciaSeguroModel,
        vencimiento_seguro: data.vencVigenciaSeguroModel,
        cert_rev_tecnica: data.revisionTecnicaModel,
        fecha_venc_rev_tecnica: data.vencRevisionTecnicaModel,
        permiso_circulacion: data.permisoCirculacionModel,
        fecha_venc_perm_circulacion: data.vencPermisoCirculacionModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteProveedoresCamiones = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarCamion/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 

Sección Proveedores - Datos Bancarios

*/
export const getProveedoresDatosBancarios = async (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarDatosBancarios/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveProveedoresDatosBancarios = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/crearDatoBancario`,
      {
        id_carrier: data.id,
        id_bank: data.bancoModel.id,
        account_type: data.tipoCuentaModel.id,
        account_number: data.numeroCuentaModel,
        email_notification: data.emailNotificacionModel,
        name: data.destinatarioModel,
        rut: data.rutDestinatarioModel,
        // id_status: data.estadoModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateProveedoresDatosBancarios = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarDatoBancario/${data.id}`,
      {
        id: data.id,
        id_bank: data.bancoModel.id,
        account_type: data.tipoCuentaModel.id,
        account_number: data.numeroCuentaModel,
        email_notification: data.emailNotificacionModel,
        name: data.destinatarioModel,
        rut: data.rutDestinatarioModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deshabilitarProveedoresDatosBancarios = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarDatoBancario/${data.id}`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteProveedoresDatosBancarios = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarDatoBancario/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 





Sección Mantenedor Regional 

*/

// Paises
export const getPaises = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/paises`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const savePais = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/paises`,
      {
        name: data.nombrePaisModel,
        code: data.codigoIsoModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updatePais = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/paises`,
      {
        id: data.id,
        name: data.nombreModel,
        code: data.codigoModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deletePais = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/paises/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 

  Regiones 

*/
export const getRegiones = async () => 
  axios.get(`${RUTA_SERVIDOR_BACKEND}/regiones`, 
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  ).then(({ data }) => data);


export const getRegionesPorPais = async (id) => {

  let dataAux;

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarRegionesPorPais/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(( {data} ) => {
      dataAux = data;
    });

    return dataAux;

}


// Agregar región
export const saveRegion = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/regiones`,

      {
        name: data.nombreRegionModel,
        id_country: data.idCountryModel.id,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// export const updateRegion = async (data) => 
//   // Insertar
//   await axios
//     .put(`${RUTA_SERVIDOR_BACKEND}/regiones`, 
//     {
//       id: data.id,
//       pais: data.paisModel.id,
//       region: data.nombreModel,
//     },
//     {
//       headers: {
//         Authorization: `Bearer ${localStorage.getItem("token")}`,
//       },
//     });
export const updateRegion = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .put(`${RUTA_SERVIDOR_BACKEND}/regiones`,
      {
        id: data.id,
        pais: data.paisModel.id,
        region: data.nombreModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico de región
export const deleteRegion = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/regiones/${data.id}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 

  Provincia 

*/
export const getProvincias = async () =>
  axios.get(`${RUTA_SERVIDOR_BACKEND}/provincias`,
    {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }
  ).then(({ data }) => data);

export const getProvinciasPorRegion = async (id) => {

  let dataAux;

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarProvinciasPorRegion/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then(({ data }) => {
      dataAux = data;
    });

    return dataAux;
}

// Agregar provincia
export const saveProvincia = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/provincias`, {
      name: data.nombreProvinciaModel,
      id_region: data.idRegionModel.id,
    },
    {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateProvincia = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .put(`${RUTA_SERVIDOR_BACKEND}/provincias`, 
      {
        id: data.id,
        region: data.regionModel.id,
        provincia: data.provinciaModel
    },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then(function ({ status }) {
        dataResponse = status;
        estadoResponse = false;
      })
      .catch(({ response }) => {
        dataResponse = response.data;
        estadoResponse = true;
      });
      dataAux.push({ error: estadoResponse, data: dataResponse });

      return dataAux[0];
};

// Borrado lógico provincia
export const deleteProvincia = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/provincias/${data.id}`,
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 

/* 

  Comunas 

*/
// Obtener comunas
export const getComunas = async (id) =>{
 
  let dataAux;

  axios.get(`${RUTA_SERVIDOR_BACKEND}/comunas/${id}`).
  
  
  then(({ data }) => {
    dataAux = data;
  },
{
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  });

  return dataAux;
}

// Agregar comuna
export const saveComuna = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();  

  // Insertar
  await axios
    .post(`${RUTA_SERVIDOR_BACKEND}/comunas`, 
      {
      id_provincia  : data.id_provincia,
      name          : data.comuna
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      }
    ).then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const getComunaPorProvincia = async (id) => {

  let dataAux;

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarComunasPorProvincia/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then(({ data }) => {
      dataAux = data;
    });

    return dataAux;
}

// Actualizar comuna
export const updateComuna = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .put(`${RUTA_SERVIDOR_BACKEND}/comunas`, {
      id: data.id,
      provincia: data.provinciaModel.id,
      comuna: data.comunaModel,
    },{
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico comuna
export const deleteComuna = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/comunas/${data.id}`,{
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 

/* 

  Localidades 

*/
// Obtener Localidades
export const getLocalidad = async () => {

  let dataAux;

  axios.get(`${RUTA_SERVIDOR_BACKEND}/localidades`).then(({ data }) => {
    dataAux = data;
  });

  return dataAux;
}


export const getLocalidadesPorComuna = async (id) => {

  let dataAux;

  await axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarLocalidadesPorComuna/${id}`, 
      {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    }).then(({ data }) => {
      dataAux = data;
    });

    return dataAux;

}

// Agregar Localidad
export const saveLocalidad = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/localidades`,
      {
        id_comuna : data.id_comuna,
        name      : data.localidad
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        }
      },
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const existLocalidad = async (payload) => (
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/localidades/find`, payload, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    }
  })
);

// Actualizar localidad
export const updateLocalidad = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
  .put(`${RUTA_SERVIDOR_BACKEND}/localidades`,data,
    // , {
    // id: data.id,
    // comuna: data.comunaModel.id,
    // localidad: data.localidadModel,
  // },
  {
    headers: {
    Accept: "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`
  }
  })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
      
      store.state.administracion.mantenedorRegionalFlagCounter = store.state.administracion.mantenedorRegionalFlagCounter +1;      
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico Localidad
export const deleteLocalidad = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/localidades/${data.id}`,
      {
        headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 




Sección Puertos 

*/

export const getPuertos = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/puertos`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const savePuertos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/puertos`,
      {
        name: data.nombreModel,
        code: data.codigoModel,
        id_country: data.paisModel.id,
        id_destination: data.zonaModel.id,
        address: data.direccionModel,
        lat: data.latitudModel,
        lon: data.longitudModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Actualizar
export const updatePuertos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/puertos`,
      {
        id: data.id,
        name: data.nombreModel,
        code: data.codigoModel,
        id_country: data.paisModel.id,
        id_destination: data.zonaModel.id,
        address: data.direccionModel,
        lat: data.latitudModel,
        lon: data.longitudModel,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Deshabilitar
export const deshabilitarPuerto = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarPuerto`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deletePuerto = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/puertos/${data.id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
/* 





Sección Destinos 

*/

export const getDestinos = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/destinos`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

// Insertar destinos
export const saveDestinos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/destinos`,
      {
        name: data.nombreModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Actualizar destinos
export const updateDestinos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/destinos`,
      {
        id: data.id,
        name: data.nombreModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deleteDestino = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/destinos/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
/* 





Sección Contenedores - Contenedores 

*/

export const getContenedores = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/contenedores`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveContenedores = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/contenedores`,
      {
        code: data.codigoModel,
        type: data.tipoModel,
        weight: data.anchoModel,
        height: data.altoModel,
        leng: data.largoModel,
        cubic_capacity: data.volumenModel,
        cargosmart_code: data.cargoSmartModel,
        inttra_code: data.inttraModel,
        cosco_code: data.codigoCoscoModel,
        with_ac: data.acModel,
        with_frozen: data.frozenModel,
        id_container_type: data.containerTypeModel.id,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Actualizar
export const updateContenedor = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarContenedor`,
      {
        id: data.id,
        code: data.codigoModel,
        type: data.tipoModel,
        weight: data.anchoModel,
        height: data.altoModel,
        leng: data.largoModel,
        cubic_capacity: data.volumenModel,
        cargosmart_code: data.cargoSmartModel,
        inttra_code: data.inttraModel,
        cosco_code: data.codigoCoscoModel,
        with_ac: data.acModel,
        with_frozen: data.frozenModel,
        id_container_type: data.containerTypeModel.id,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Deshabilitar
export const deshabilitarContenedor = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarContenedor`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deleteContenedor = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/contenedores/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
/* 
/* 





Sección Contenedores - Depósitos 

*/

export const getDepositos = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/depositos`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const getRegionesByPais = (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/getRegionesByPais/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const getProvinciasByRegion = (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/getProvinciasByRegion/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const getComunasByProvincia = (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/getComunasByProvincia/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);
  export const getLocalidadesByComuna = (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/getLocalidadesByComuna/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveDepositos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/depositos`, data,
      // {
      //   name: data.nombreModel,
      //   address: data.direccionModel,
      //   id_country: data.paisModel.id,
      //   id_zone: data.zonaModel.id,
      //   id_region: data.regionModel.id,
      //   id_provincia: data.provinciaModel.id,
      //   id_comuna: data.comunaModel.id,
      //   id_localidad: data.localidadModel.id,
      //   id_port: data.puertoModel.id,
      //   lat: data.latitudModel,
      //   lon: data.longitudModel,
      //   contact_name: data.nombreContactoModel,
      //   contact_phone: data.telefonoContactoModel,
      //   contact_email: data.emailContactoModel,
      // },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const existDeposito = async (payload) => (
  await axios.post(`${RUTA_SERVIDOR_BACKEND}/depositos/find`, payload, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    }
  })
);

// Actualizar
export const updateDepositos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarDeposito`, data,
      // {
      //   id: data.id,
      //   name: data.nombreModel,
      //   address: data.direccionModel,
      //   id_country: data.paisModel.id,
      //   id_zone: data.zonaModel.id,
      //   id_region: data.regionModel.id,
      //   id_provincia: data.provinciaModel.id,
      //   id_comuna: data.comunaModel.id,
      //   id_localidad: data.localidadModel.id,
      //   id_port: data.puertoModel.id,
      //   lat: data.latitudModel,
      //   lon: data.longitudModel,
      //   contact_name: data.nombreContactoModel,
      //   contact_phone: data.telefonoContactoModel,
      //   contact_email: data.emailContactoModel,
      // },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Deshabilitar
export const deshabilitarDeposito = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarDeposito`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deleteDeposito = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/depositos/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
/* 




Sección Contenedores - Atmósferas

*/

export const getAtmosferas = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/atmosferas`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveAtmosferas = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/atmosferas`,
      {
        name: data.nombreModel,
        active: data.estadoModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Actualizar
export const updateAtmosferas = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarAtmosfera`,
      {
        id: data.id,
        name: data.nombreModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Deshabilitar
export const deshabilitarAtmosfera = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarAtmosfera`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deleteAtmosfera = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/atmosferas/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
/* 




Sección Contenedores - Tipos de Movimiento

*/

export const getTiposMovimiento = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/movimientos`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveTiposMovimiento = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/movimientos`,
      {
        name: data.nombreModel,
        active: data.estadoModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Actualizar
export const updateTiposMovimiento = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarMovimiento`,
      {
        id: data.id,
        name: data.nombreModel,
        active: data.estadoModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Deshabilitar
export const deshabilitarMovimiento = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarMovimiento`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deleteMovimiento = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/movimientos/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
/* 




Sección Contenedores - Zonas de Consolidación

*/

export const getZonasConsolidacion = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/zonasConsolidacion`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveZonasConsolidacion = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/zonasConsolidacion`,
      {
        name: data.nombreModel,
        active: data.estadoModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Actualizar
export const updateZonasConsolidacion = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarZonaConsolidacion`,
      {
        id: data.id,
        name: data.nombreModel,
        active: data.estadoModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Deshabilitar
export const deshabilitarZonaConsolidacion = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarZonaConsolidacion`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deleteZonasConsolidacion = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/zonasConsolidacion/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 




Sección Pallets

*/

export const getPallets = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/pallets`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const savePallets = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/pallets`,
      {
        code: data.codigoModel,
        description: data.descripcionModel,
        leng: data.largoModel,
        width: data.anchoModel,
        area: data.areaModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Actualizar
export const updatePallets = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarPallet`,
      {
        id: data.id,
        code: data.codigoModel,
        description: data.descripcionModel,
        leng: data.largoModel,
        width: data.anchoModel,
        area: data.areaModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Deshabilitar
export const deshabilitarPallet = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarPallet`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deletePallet = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/pallets/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
/* 




Sección Condiciones

*/

export const getCondiciones = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/condiciones`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveCondiciones = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/condiciones`,
      {
        code: data.codigoModel,
        name: data.descripcionModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Actualizar
export const updateCondiciones = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarCondicion`,
      {
        id: data.id,
        code: data.codigoModel,
        name: data.descripcionModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Deshabilitar
export const deshabilitarCondicion = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarCondicion`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deleteCondicion = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/condiciones/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
/* 




Sección Naves

*/

export const getNaves = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/naves`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveNaves = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/naves`, data,
      // {
      //   nave: data.nombreModel,
      //   type: data.tipoModel.id,
      //   description: data.descripcionModel,
      //   pallets_capacity: data.capacidadPalletsModel,
      //   imo_code: data.codigoImoModel,
      //   rh40_capacity: data.capacidadRhModel,
      //   teu_capacity: data.capacidadTeuModel,
      //   total_pallets: data.totalPalletsModel,
      //   speed: data.velocidadModel,
      // },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Actualizar
export const updateNaves = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/naves`, data,
      // {
      //   id: data.id,
      //   nave: data.nombreModel,
      //   type: data.tipoModel.id,
      //   description: data.descripcionModel,
      //   pallets_capacity: data.capacidadPalletsModel,
      //   imo_code: data.codigoImoModel,
      //   rh40_capacity: data.capacidadRhModel,
      //   teu_capacity: data.capacidadTeuModel,
      //   total_pallets: data.totalPalletsModel,
      //   speed: data.velocidadModel,
      // },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Deshabilitar
export const deshabilitarNave = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarNave`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deleteNave = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/naves/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
/* 




Sección Navieras

*/

export const getNavieras = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/navieras`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveNavieras = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/navieras`,
      {
        name: data.nombreModel,
        code: data.codigoModel,
        is_cargoSmart: data.cargoSmartModel,
        is_line: data.lineaModel,
        is_charter: data.charterModel,
        is_inttra: data.inttraModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Actualizar naviera
export const updateNavieras = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Actualizar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/navieras`,
      {
        id: data.id,
        name: data.nombreModel,
        code: data.codigoModel,
        is_cargoSmart: data.cargoSmartModel,
        is_line: data.lineaModel,
        is_charter: data.charterModel,
        is_inttra: data.inttraModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Deshabilitar
export const deshabilitarNaviera = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarNaviera`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deleteNaviera = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/navieras/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
/* 




Sección Productos

*/
// Listar productos
export const getProductos = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/productos`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

// Insertar nuevo producto
export const saveProductos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/productos`,
      {
        name: data.nombreModel,
        idProductType: data.categoriaModel.id,
        contenedores: data.contenedoresModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )

    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Actualizar producto
export const updateProductos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Actualizar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/productos`,
      {
        name: data.nombreModel,
        id: data.id,
        contenedoresSeleccionados: data.contenedoresModel.map(({ id }) => id)
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Deshabilitar
export const deshabilitarProducto = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarProducto`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deleteProducto = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/productos/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
/* 



 

Sección Límite Planificaciones

*/

export const getLimitePlanificaciones = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/limitePlanificaciones`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

// Actualizar limite planificaciones
export const updateLimitePlanificaciones = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Actualizar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarLimitePlanificaciones`,
      {
        id: data.id,
        id_dia: data.diaModel.id,
        id_semana: data.semanaModel.id,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};
/* 

Sección Embarcador

*/

export const getEmbarcador = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/embarcador`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveEmbarcador = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/embarcador`,
      {
        name: data.nombreModel,
        id_country: data.paisModel.id,
        phone: data.telefonoModel,
        active: data.estadoModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Actualizar embarcador
export const updateEmbarcador = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Actualizar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/embarcador`,
      {
        id: data.id,
        name: data.nombreModel,
        id_country: data.paisModel.id,
        phone: data.telefonoModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Deshabilitar
export const deshabilitarEmbarcador = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarEmbarcador`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

// Borrado lógico usuario
export const deleteEmbarcador = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/embarcador/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 

Sección Embarcadores - Direcciones

*/
export const getEmbarcadoresDirecciones = async (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarDireccionesEmbarcador/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveEmbarcadoresDirecciones = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/crearDireccionEmbarcador`,
      {
        id_shipper: data.id,
        address: data.direccionModel,
        id_comuna: data.comunaModel.id,
        id_region: data.regionModel.id,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateEmbarcadoresDirecciones = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarDireccionEmbarcador/${data.id}`,
      {
        id: data.id,
        address: data.direccionModel,
        id_comuna: data.comunaModel.id,
        id_region: data.regionModel.id,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deshabilitarEmbarcadoresDirecciones = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarDireccionEmbarcador/${data.id}`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteEmbarcadoresDirecciones = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarDireccionEmbarcador/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 

Sección Embarcadores - Contactos

*/
export const getEmbarcadoresContactos = async (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarContactosEmbarcador/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveEmbarcadoresContactos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/crearContactoEmbarcador`,
      {
        id_shipper: data.id,
        firstname: data.nombreModel,
        lastname: data.apellidosModel,
        position: data.cargoModel,
        tel: data.telefonoModel,
        fax: data.faxModel,
        cel: data.celularModel,
        email: data.emailModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateEmbarcadoresContactos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarContactoEmbarcador/${data.id}`,
      {
        id: data.id,
        firstname: data.nombreModel,
        lastname: data.apellidosModel,
        position: data.cargoModel,
        tel: data.telefonoModel,
        fax: data.faxModel,
        cel: data.celularModel,
        email: data.emailModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deshabilitarEmbarcadoresContactos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarContactoEmbarcador/${data.id}`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteEmbarcadoresContactos = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarContactoEmbarcador/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/*

Temporadas



*/

export const getTemporadas = async () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/temporadas`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const saveTemporada = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/temporadas`,
      {
        name: data.nombreTemporadaModel,
        from_date: data.fechaInicioModel,
        to_date: data.fechaTerminoModel,
        aditional_service: data.serviciosAdicionalesTerrestreModel,
        general_conditions: data.condicionesGeneralesTerrestreModel,
        aditional_service_d: data.serviciosAdicionalesDocumentalModel,
        general_conditions_d: data.condicionesGeneralesDocumentalModel,
        aditional_service_td: data.serviciosAdicionalesTdModel,
        general_conditions_td: data.condicionesGeneralesTdModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const updateTemporada = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/temporadas`,
      {
        id: data.id,
        name: data.nombreTemporadaModel,
        from_date: data.fechaInicioModel,
        to_date: data.fechaTerminoModel,
        aditional_service: data.serviciosAdicionalesTerrestreModel,
        general_conditions: data.condicionesGeneralesTerrestreModel,
        aditional_service_d: data.serviciosAdicionalesDocumentalModel,
        general_conditions_d: data.condicionesGeneralesDocumentalModel,
        aditional_service_td: data.serviciosAdicionalesTdModel,
        general_conditions_td: data.condicionesGeneralesTdModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteTemporada = async (id) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarTemporada/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

/* 

  Tiers

*/

export const getTiers = async (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/tiersPorTemporada/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const updateTier = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .put(
      `${RUTA_SERVIDOR_BACKEND}/actualizarTier/${data.id}`,
      {
        id: data.id,
        id_season: data.id_season,
        type: data.typeModel.id,
        tier_number: data.tiernumberModel.id,
        margin: parseInt(data.marginModel),
        id_status: data.estadoModel,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const saveTiers = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  // Insertar
  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/crearTier`,
      {
        id_season: data.id,
        type: data.typeModel.id,
        tier_number: parseInt(data.tiernumberModel.id),
        margin: parseInt(data.marginModel),
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deshabilitarTier = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .post(
      `${RUTA_SERVIDOR_BACKEND}/deshabilitarTier`,
      {
        id: data.id,
        estado: data.estado,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    )
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const deleteTier = async (data) => {
  let dataResponse;
  let estadoResponse;
  let dataAux = new Array();

  await axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/eliminarTier/${data.id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(function ({ status }) {
      dataResponse = status;
      estadoResponse = false;
    })

    .catch(({ response }) => {
      dataResponse = response.data;
      estadoResponse = true;
    });

  dataAux.push({ error: estadoResponse, data: dataResponse });

  return dataAux[0];
};

export const getSeccionesRoles = (id) =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/obtenerSeccionesList/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);


export const getListarPermisos = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/listarPermisos`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);

export const listarPermisosUsuario = (id) => (
  axios.get(`${RUTA_SERVIDOR_BACKEND}/listarPermisosUsuario/${id}`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
)
export const cambiarPermisosUsuario = (id) => (
  axios.put(`${RUTA_SERVIDOR_BACKEND}/cambiarPermisosUsuario/${id}`, {}, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
)


export const initTiers = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/admin/tier/init`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({data}) => data);


export const storageTier = form =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/admin/tier`, form,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({data}) => data);

export const getTiersAdmin = () =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/admin/tier`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({data}) => data);

export const getTierAdmin = id =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/admin/tier/${ id }`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({data}) => data);


export const updateTierAdmin = form =>
  axios
    .put(`${RUTA_SERVIDOR_BACKEND}/admin/tier`, form ,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({data}) => data);

export const deleteTierAdmin = id =>
  axios
    .delete(`${RUTA_SERVIDOR_BACKEND}/admin/tier/${ id }`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({data}) => data);

export const getTiersAdminFilter = form =>
  axios
    .post(`${RUTA_SERVIDOR_BACKEND}/admin/tier/filter`, form ,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
    .then(({data}) => data);


    export const getConfiguraciones = (id) =>
      axios
        .get(`${RUTA_SERVIDOR_BACKEND}/administracion/clientes/configuraciones/${id}`, {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then(({ data }) => data);
    
    export const updateConfiguraciones = async (id, id_tier) => {
    
      let dataResponse;
      let estadoResponse;
      let dataAux = new Array();
        
      // Insertar
      await axios
        .put(
          `${RUTA_SERVIDOR_BACKEND}/administracion/clientes/configuraciones/${id}/${id_tier}`,
          {
            id,
            id_tier
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then(function ({ status }) {
          dataResponse = status;
          estadoResponse = false;
        })
    
        .catch(({ response }) => {
          dataResponse = response.data;
          estadoResponse = true;
        });
    
      dataAux.push({ error: estadoResponse, data: dataResponse });
    
      return dataAux[0];
    
    };

export const getServiceTypeByExtraCostoTypeId = id =>
  axios
    .get(`${RUTA_SERVIDOR_BACKEND}/admin/tier/serviceType/${id}`, {
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
    .then(({ data }) => data);